<template>
  <div>
    <el-table :data="tableList" style="width: 100%" :max-height="height">
      <el-table-column
        label="所属地点"
        prop="place"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="总数量"
        prop="stock"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="已借出"
        prop="lendNum"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="可借出"
        prop=""
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.stock - scope.row.lendNum }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="损坏"
        prop="damageNum"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="丢失"
        prop="loseNum"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div
            style="font-size: 16px; margin-right: 10px; color: #4fa27d"
            @click="increase(scope.row)"
          >
            增加库存
          </div>
          <div
            style="font-size: 16px; color: #4fa27d"
            @click="reduce(scope.row)"
          >
            减少库存
          </div>
        </template>
      </el-table-column>
    </el-table>
    <MyDialog :visible.sync="uploadDialog" :type="type" :row="row" @changeSubmit="$emit('changeSubmit')" />
  </div>
</template>

<script>
import MyDialog from "./inventoryDialog.vue";
export default {
  name: "inventoryDialog",
  components: {
    MyDialog,
  },
  props: {
    tableList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      height: window.innerHeight - 260,
      uploadDialog: false,
      type: "",
      row: {},
    };
  },
  mounted() {},
  methods: {
    // 增加库存
    increase(row) {
      this.type = "1";
      this.row = row;
      this.uploadDialog = true;
    },
    // 减少库存
    reduce(row) {
      this.type = "2";
      this.row = row;
      this.uploadDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
::v-deep {
  .rowTable {
    thead {
      tr {
        th {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fafafa !important;
          height: 100px !important;
          border: none !important;
        }
      }
    }
  }
}
</style>
